import { storeToRefs } from 'pinia'
import { useStore } from 'vuex'
import { computed } from 'vue'

import useCheckHelpers from '@app/application/communication/sections/communication/composables/use-check-helpers'
import {
  doneChecks,
  pendingChecks,
} from '@app/application/sf-assistant-checks/utils'

import { useCommsFilterStore } from '@app/application/communication/store/comms-filters'
import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'
import { useHighlightedCard } from '@app/shared/pinia/highlighted-card'

/**
 * Composable function to get the header item data for the communication sidebar header
 * TODO: Refactor to TS once the comms store is refactored to TS
 */
export default function useItemCounts() {
  const { checkCheckedByAllParticipants } = useCheckHelpers()

  const checksStore = useChecksStore()
  const commsStore = useStore()

  const notes = computed(() => commsStore.getters.notes)
  const todos = computed(() => commsStore.getters.todos)
  const allChecks = computed(() => commsStore.getters.allChecks)
  const filteredSfAssistantRemarks = computed(
    () => commsStore.getters.filteredSfAssistantRemarks
  )
  const notificationsByRemarkId = computed(
    () => commsStore.getters.notificationsByRemarkId
  )

  const { checks } = storeToRefs(checksStore)

  const allNotesCount = computed(() => Object.keys(notes.value).length)
  const unreadNotesCount = computed(() => {
    return Object.values(notes.value).reduce((acc, note) => {
      const notification = notificationsByRemarkId.value[note.id]
      return notification && !notification.read ? acc + 1 : acc
    }, 0)
  })

  const allTodosCount = computed(
    () =>
      todosCount.value + doneSfAChecksCount.value + pendingSfAChecksCount.value
  )
  const todosCount = computed(() => Object.keys(todos.value).length)
  const doneSfAChecksCount = computed(
    () => doneChecks(checks.value, filteredSfAssistantRemarks.value).length
  )
  const pendingSfAChecksCount = computed(
    () => pendingChecks(checks.value, filteredSfAssistantRemarks.value).length
  )
  const pendingTodosCount = computed(
    () =>
      Object.values(todos.value).filter((todo) => !todo.done).length +
      pendingSfAChecksCount.value
  )

  const unreadTodosCount = computed(() => {
    return Object.values(todos.value).reduce((acc, todo) => {
      const notification = notificationsByRemarkId.value[todo.id]
      return notification && !notification.read ? acc + 1 : acc
    }, 0)
  })

  const allChecksCount = computed(() => Object.keys(allChecks.value).length)
  const pendingChecksCount = computed(
    () =>
      Object.values(allChecks.value).filter((check) => {
        return (
          !checkCheckedByAllParticipants(check) && !check.markedNotApplicableBy
        )
      }).length
  )

  function handleItemClick(type) {
    const filterStore = useCommsFilterStore()
    const highlightedCardStore = useHighlightedCard()

    filterStore.toggleTypeFilter(type)
    highlightedCardStore.unsetHighlightedCard()
    window.eventHub.$emit('clearAnchor')
  }

  return {
    allChecksCount,
    allNotesCount,
    allTodosCount,
    handleItemClick,
    pendingChecksCount,
    pendingTodosCount,
    unreadNotesCount,
    unreadTodosCount,
  }
}
